<template>
    <div>
        <v-alert dense border="bottom" type="primary" icon="mdi-information">
            PARTS RECOMMEND
        </v-alert>
        <v-alert>
            <v-card-text>
                <v-container fluid>
                    <v-simple-table>
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <th style="width: 60px; text-align: center">#</th>
                                    <th>Part Number</th>
                                    <th style="width: 200px">Serial</th>
                                    <th style="width: 200px; text-align: center">Status</th>
                                    <th style="width: 160px; text-align: center">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-if="partRows.length === 0">
                                    <td colspan="5" class="text-center grey--text pa-5">
                                        ยังไม่มี Part — กด "+ เพิ่ม Part" ด้านล่าง
                                    </td>
                                </tr>
                                <tr
                                    v-for="(row, index) in partRows"
                                    :key="row.id"
                                    :class="{ 'invalid-row': row.status === 'Invalid' }"
                                >
                                    <td class="text-center grey--text">{{ index + 1 }}</td>
                                    <td>
                                        <v-text-field
                                            v-model="row.part_no"
                                            placeholder="Input Part No."
                                            dense
                                            flat
                                            solo
                                            hide-details
                                            @input="onPartChange(row)"
                                        />
                                    </td>
                                    <td>
                                        <v-text-field
                                            v-model="row.serial"
                                            placeholder="Input Serial"
                                            dense
                                            flat
                                            solo
                                            hide-details
                                        />
                                    </td>
                                    <td class="text-center">
                                        <v-progress-circular
                                            v-if="row.verifying"
                                            indeterminate
                                            size="20"
                                            width="2"
                                            color="blue darken-2"
                                        />
                                        <span v-else-if="row.status === 'pending'" class="grey--text">—</span>
                                        <v-tooltip v-else-if="row.status === 'Invalid'" bottom>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-chip
                                                    small
                                                    color="red darken-1"
                                                    dark
                                                    v-bind="attrs"
                                                    v-on="on"
                                                >
                                                    <v-icon left x-small>mdi-close-circle</v-icon>
                                                    Invalid
                                                </v-chip>
                                            </template>
                                            <span>Part นี้ไม่ถูกต้อง — จะไม่ถูกส่ง กรุณาแก้ไข Part No. หรือลบออก</span>
                                        </v-tooltip>
                                        <v-chip
                                            v-else
                                            small
                                            :color="statusColor(row.status)"
                                            dark
                                        >
                                            <v-icon left x-small>{{ statusIcon(row.status) }}</v-icon>
                                            {{ statusLabel(row.status) }}
                                        </v-chip>
                                    </td>
                                    <td class="text-center">
                                        <div style="display: flex; align-items: center; justify-content: center; gap: 6px; padding-top: 6px;">
                                            <v-btn
                                                v-if="!isVerified(row)"
                                                :disabled="!canVerify(row)"
                                                :loading="row.verifying"
                                                color="blue darken-2"
                                                dark
                                                small
                                                @click="verifyPart(row)"
                                            >
                                                <v-icon left small>mdi-database-search</v-icon>
                                                Verify
                                            </v-btn>
                                            <v-btn
                                                icon
                                                small
                                                color="red darken-1"
                                                @click="removeRow(row.id)"
                                                title="ลบ"
                                            >
                                                <v-icon>mdi-delete</v-icon>
                                            </v-btn>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>

                    <v-btn
                        outlined
                        small
                        color="grey"
                        class="mt-3"
                        :disabled="!canAddRow"
                        @click="addRow"
                    >
                        <v-icon left small>mdi-plus</v-icon>
                        เพิ่ม Part
                    </v-btn>
                </v-container>
            </v-card-text>
        </v-alert>
    </div>
</template>

<script>
import axios from "axios"

let _rowId = 0

const VERIFIED_STATUSES = ["Recommended", "Backordered", "Backordered แต่มี Offer"]

export default {
    name: "PartInformation",
    props: ["information", "condition"],

    data() {
        return {
            partRows: [],
            deletedParts: [],
        }
    },

    watch: {
        information() {
            this.getCategory()
            if (
                this.condition.status === "editcase" ||
                this.condition.status === "subcase"
            ) {
                this.loadExistingParts()
            }
        },
    },

    mounted() {
        console.log("[PartInformation] mounted — information.project_id:", this.information.project_id)
        this.getCategory()
        this.addRow()
        if (
            this.condition.status === "editcase" ||
            this.condition.status === "subcase"
        ) {
            this.loadExistingParts()
        }
    },

    computed: {
        canAddRow() {
            if (!this.partRows.length) return true
            const last = this.partRows[this.partRows.length - 1]
            return last.status !== "Invalid" && last.status !== "pending"
        },
    },

    methods: {
        async getCategory() {
            console.log("[getCategory] project_id:", this.information.project_id, "| problem_group_id:", this.information.problem_group_id)
            if (!this.information.project_id || !this.information.problem_group_id) {
                console.log("[getCategory] SKIPPED — missing project_id or problem_group_id")
                return
            }
            const url = `${process.env.VUE_APP_ROOT_API}/api/nonhp/newcase/${this.information.project_id}/${this.information.problem_group_id}`
            try {
                const { data } = await axios.get(url)
                console.log("[getCategory] API response:", data)
                console.log("[getCategory] problem_type before set:", this.information.problem_type)
                this.information.problem_type = data.problem_type
                this.information.is_special = data.is_special
                console.log("[getCategory] problem_type after set:", this.information.problem_type)
            } catch (error) {
                console.log(error)
            }
        },

        addRow() {
            this.partRows.push({
                id: ++_rowId,
                part_no: "",
                serial: "",
                status: "pending",
                verifying: false,
                part_issue_id: null,
                status_update: "order",
            })
        },

        removeRow(id) {
            const row = this.partRows.find((r) => r.id === id)
            if (row && row.part_issue_id) {
                this.deletedParts.push({
                    part_issue_id: row.part_issue_id,
                    part_no: row.part_no,
                    status_update: "delete",
                })
            }
            this.partRows = this.partRows.filter((r) => r.id !== id)
            this.syncToInformation()
        },

        onPartChange(row) {
            row.status = "pending"
            this.syncToInformation()
        },

        isVerified(row) {
            return VERIFIED_STATUSES.includes(row.status)
        },

        canVerify(row) {
            const branchId = this.information.branch_id
            const projectId = this.information.project_id
            return (
                branchId != null &&
                branchId !== "" &&
                projectId != null &&
                projectId !== "" &&
                row.part_no.trim() !== "" &&
                !row.verifying
            )
        },

        async verifyPart(row) {
            if (!this.canVerify(row)) return
            row.verifying = true

            const body = {
                project_id: Number(this.information.project_id),
                branch_id: Number(this.information.branch_id),
                part_no: row.part_no.trim(),
                serial: row.serial.trim() || "",
            }

            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }

            try {
                const url = `${process.env.VUE_APP_ROOT_API}/api/nonhp/wms/verify-part`
                const { data } = await axios.post(url, body, options)
                row.status = data.status || "Invalid"
            } catch (error) {
                console.error("verify-part error:", error)
                row.status = "Invalid"
            } finally {
                row.verifying = false
                this.syncToInformation()
            }
        },

        syncToInformation() {
            const activeParts = this.partRows
                .filter((r) => r.part_no.trim() !== "" && this.isVerified(r))
                .map((r) => {
                    const item = {
                        part_no: r.part_no.trim(),
                        serial: r.serial.trim(),
                        status: r.status,
                        status_update: r.status_update || "order",
                    }
                    if (r.part_issue_id) item.part_issue_id = r.part_issue_id
                    return item
                })
            this.information.part = [...activeParts, ...this.deletedParts]
        },

        loadExistingParts() {
            console.log("[loadExistingParts] called — information.parts:", this.information.parts)
            console.log("[loadExistingParts] information.part:", this.information.part)
            if (!this.information.parts || !this.information.parts.length) return
            this.deletedParts = []
            this.partRows = this.information.parts.map((p) => ({
                id: ++_rowId,
                part_no: p.part_name || p.part_no || "",
                serial: p.serial || "",
                status: p.status || "pending",
                verifying: false,
                part_issue_id: p.part_issue_id || null,
                status_update: "update",
            }))
            this.syncToInformation()
        },

        // expose for parent $refs.partinfor.delpart()
        delpart() {
            this.partRows = []
            this.syncToInformation()
            this.addRow()
        },

        statusColor(status) {
            const map = {
                Recommend: "green darken-1",
                Backordered: "orange darken-2",
                "Backordered แต่มี Offer": "blue darken-2",
                Invalid: "red darken-1",
            }
            return map[status] || "grey"
        },

        statusIcon(status) {
            const map = {
                Recommend: "mdi-check-circle",
                Backordered: "mdi-clock-outline",
                "Backordered แต่มี Offer": "mdi-tag-outline",
                Invalid: "mdi-close-circle",
            }
            return map[status] || "mdi-help-circle"
        },

        statusLabel(status) {
            const map = {
                Recommend: "Recommend",
                Backordered: "Backordered",
                "Backordered แต่มี Offer": "Backordered + Offer",
                Invalid: "Invalid",
            }
            return map[status] || status
        },
    },
}
</script>

<style scoped>
.invalid-row td {
    background-color: #fff5f5 !important;
}
.invalid-row td:first-child {
    border-left: 3px solid #e53935;
}
</style>